const DIRECTIVE_NAME = Radio.DIRECTIVE_NAME = 'ktRadio';
export default function Radio() {
    return {
        restrict: 'A',
        scope: {
            value: `=${DIRECTIVE_NAME}`,
            field: `@${DIRECTIVE_NAME}Field`,
            values: `=${DIRECTIVE_NAME}Options`,
        },
        link,
    };

    function link($scope, $elem) {
        const {value, field, values} = $scope;

        const selected = values.find(isSelected);
        if (angular.equals(selected, value)) {
            $elem.prop('checked', true);
        }

        $scope.$watch('value.isSelected', (isChecked) => {
            $elem.prop('checked', isChecked);
        });

        $elem.on('click', () => {
            $scope.values.forEach((item) => item[field] = false);
            value[field] = true;
            $scope.$apply();
        });

        function isSelected(item) {
            return item && item.isSelected;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/radio.js